// extracted by mini-css-extract-plugin
export default {"button":"Nm-z","reviewSort":"Om-z"};